module.exports = __webpack_public_path__ + "img/image11.44c7c437.jpg";